module.exports = __webpack_public_path__ + "media/images/team/bert-d3b930a898e88ad73213dadaf2bf2444.jpg";